<template>

<div v-cloak class="receiving-numbers">

  <table class="table table--striped table--word-break table--stackable milli push-half--bottom">
    <thead v-if="assigned.length">
      <tr>
        <th>{{ $_('receiving_number') }}</th>
        <th>{{ $_('name') }}</th>
        <th>{{ $_('actions') }}</th>
      </tr>
    </thead>
    <tbody v-if="assigned.length">
      <tr v-for="number in assigned" v-bind:key="number.id">
        <td>{{ number.formattedNumber }}</td>
        <td>{{ number.name }}</td>
        <td>
          <div class="button-group flush--bottom">
            <button type="button" class="button button--small" @click="edit(number)">{{ $_('edit') }}</button>
            <button type="button" class="button button--small" @click="remove(number)">{{ $_('delete') }}</button>
          </div>
        </td>
      </tr>
    </tbody>
    <tbody v-if="!assigned.length">
      <tr>
        <td colspan="2">{{ $_('no_receiving_numbers') }}.</td>
      </tr>
    </tbody>
  </table>

  <button type="button" class="button button--small button--primary" v-if="!showForm" @click="showForm = !showForm">{{ $_('add_new') }}</button>

  <div class="grid push--top" v-if="showForm">
    <div class="grid__item one-half portable--one-whole">

      <h4>{{ $_('add_new') }} {{ $_('receiving_number').toLowerCase() }}:</h4>
      <form name="" class="form" v-on:submit.prevent="onSubmit('receivingNumber')" data-vv-scope="receivingNumber">
        <div class="grid">
          <div class="grid__item one-half portable--one-whole">
            <div class="form__line">
              <div class="form__field">
                <label for="number">{{ $_('receiving_number') }}:</label>
                <the-mask type="tel" v-validate="'required'" :mask="mask" name="number" id="number" ref="number" autofocus v-model.number="receivingNumber.number" class="field field--text" :class="{ 'parsley-error': errors.has('receivingNumber.number') }" />
                <span v-show="errors.has('receivingNumber.number')" class="parsley-errors-list ">{{ errors.first('receivingNumber.number') }}</span>
              </div>
            </div>
          </div><!--
          --><div class="grid__item one-half portable--one-whole">
            <div class="form__line">
              <div class="form__field">
                <label for="name">{{ $_('name') }}:</label>
                <input type="text" v-validate="''" name="name" id="name" v-model="receivingNumber.name" class="field field--text" :class="{ 'parsley-error': errors.has('receivingNumber.name') }">
                <span v-show="errors.has('receivingNumber.name')" class="parsley-errors-list ">{{ errors.first('receivingNumber.name') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button type="submit" class="button button--small button--primary">{{ (receivingNumber.id) ? $_('update') : $_('add') }} {{ $_('receiving_number').toLowerCase() }}</button>
          <button type="button" class="button button--small button--default" @click="clearNew()">{{ $_('cancel') }}</button>
        </div>
      </form>
      <div class="form__line push--top flush--bottom" v-if="error">
        <div class="form__field">
          <div class="parsley-error">{{ error }}</div>
        </div>
      </div>

    </div><!--
    --><div class="grid__item one-half portable--one-whole" v-if="notAssigned.length">

      <h4>{{ $_('existing_receiving_numbers_for_assignment') }}</h4>
      <table class="table table--striped table--word-break table--stackable milli push-half--bottom">
        <thead>
          <tr>
            <th>{{ $_('receiving_number') }}</th>
            <th>{{ $_('name') }}</th>
            <th>{{ $_('actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="number in notAssigned" v-bind:key="number.id">
            <td>{{ number.formattedNumber }}</td>
            <td>{{ number.name }}</td>
            <td>
              <div class="button-group flush--bottom">
                <button type="button" class="button button--small" @click="assign(number)">{{ $_('assign') }}</button>
                <button type="button" class="button button--small" @click="remove(number)">{{ $_('delete') }}</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>

</div>

</template>

<script>
import { TheMask } from 'vue-the-mask';

export default {
  name: 'receivingNumbers',
  components: {
    TheMask,
  },
  props: {
    clientId: Number,
    campaignId: Number,
  },
  data () {
    return {
      mask: '+1 (###) ###-####',
      receivingNumbers: [],
      showForm: false,
      error: null,
      receivingNumber: {
        id: null,
        number: '',
        name: '',
      }
    }
  },
  mounted () {
    this.getReceivingNumbers();
  },
  computed: {
    assigned() {
      return this.receivingNumbers.filter((n) => n.campaign_id !== null);
    },
    notAssigned() {
      return this.receivingNumbers.filter((n) => n.campaign_id === null);
    },
  },
  methods: {
    getReceivingNumbers() {
      var self = this;
      if (!self.clientId || !self.campaignId) return;
      this.$http.get(`/api/v1/clients/${self.clientId}/campaigns/${self.campaignId}/receiving`).then(
        function(response) {
          self.receivingNumbers = response.data.map((n) => { n.number = decodeURIComponent(n.number).replace('+1', ''); return n; });
        },
        function(error) {
          console.error(error);
        }
      )
    },
    clearNew() {
      this.receivingNumber = {
        id: null,
        number: '',
        name: '',
      };
      this.error = null;
      this.$validator.reset();
      this.showForm = false;
    },
    onSubmit(scope) {
      var self = this;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        if (self.receivingNumber.id) {
          self.update(self.receivingNumber)
        } else {
          self.post(self.receivingNumber);
        }
      });
    },
    post(data) {
      var self = this;
      data.number = '+1' + data.number;
      self.$http.post(`/api/v1/clients/${self.clientId}/campaigns/${self.campaignId}/receiving`, data).then(
        function(response) {
          self.getReceivingNumbers();
          self.clearNew();
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    update(data) {
      var self = this;
      data.number = '+1' + data.number;
      return self.$http.put(`/api/v1/clients/${self.clientId}/campaigns/${self.campaignId}/receiving/${data.id}`, data).then(
        function(response) {
          self.getReceivingNumbers();
          self.clearNew();
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    edit(receivingNumber) {
      this.receivingNumber = JSON.parse(JSON.stringify(receivingNumber));
      this.error = null;
      this.showForm = true;
      this.$nextTick(() => this.$refs.number.$el.focus());
    },
    assign(number) {
      var self = this;
      this.update(number).then(() => self.showForm = true);
    },
    remove(data) {
      if (!confirm(this.$_('receiving_number_delete_confirmation'))) { return false; }
      var self = this;
      self.$http.delete(`/api/v1/clients/${self.clientId}/campaigns/${self.campaignId}/receiving/${data.id}`).then(
        function(response) {
          self.getReceivingNumbers();
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    },
  }
}

</script>

<style lang="scss">
// @import '../../../css/vars';
</style>



// WEBPACK FOOTER //
// src/ReceivingNumbers.vue